interface IProps {
    currentYear: number;
    closeModal: (selectedYear: number) => void;
}

const ChangeYear: React.FC<IProps> = ({ currentYear, closeModal }) => {

    const years = [ 2023, 2024, 2025, 2026 ];

    function requestToCloseModal(chosenYear: number) {
        closeModal(chosenYear);
    }

    return (
        <div className="w-11/12 lg:w-1/4 mx-auto">
            <div className='bg-br-blue-300'>
                
                <div>
                    <h1 className="text-4xl md:text-6xl font-thin text-center pb-1 pt-3">Change the year</h1>
                    <hr className="mx-auto mt-3 mb-1" />

                    <div className="flex flex-wrap justify-center">    
                        {years.map(year => (
                            <div 
                                className={`flex-grow px-4 pt-2 pb-3 text-xl text-center cursor-pointer ${year === currentYear ? `underline` : 'hover:underline decoration-slate-300'}`}
                                onClick={() => requestToCloseModal(year)}>
                                {year}
                            </div>
                        ))}
                    </div>

                    <div className="flex justify-end mx-5">
                        <button className="px-3 py-1 mx-1 mb-2 bg-gray-600 hover:brightness-110" onClick={() => requestToCloseModal(currentYear)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangeYear;